/** @format */

export interface Donations {
  donation: number;
  donation_type: string;
}
